import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import './LoginLogout.css';
import { Image, Card, Nav } from "react-bootstrap";
import { useM365SignIn } from "../../api/useSignIn";
import Button from '@mui/material/Button';

const logo: string = require('../../images/logo.svg').default;

function SignIn({ showNavSetter }: {
  showNavSetter: (show: boolean) => void;
}) {
  const nav = useNavigate();
  const m365SignIn = useM365SignIn();
  showNavSetter(false);

  useEffect(() => {
    if(localStorage.getItem('JWT') !== null){
        showNavSetter(true);
        return nav("/")
    }
  });

  const handleM365Click = async () => {
    await m365SignIn.mutateAsync();
  };

  return (
    <div className="center-card">
        <Card style={{ height: '220px', border: '20px', marginTop: '20px'}}>
        <Card.Title>
            <Nav.Item className="center-image">
              <Nav.Link href="/">
                <Image src={logo} height={35} width={340}/>
              </Nav.Link>
            </Nav.Item>
        </Card.Title>
        <Card.Body>
            {process.env.REACT_APP_M365_AUTH === 'YES' && (
              <div style={{display: 'flex', justifyContent: 'center'}}>
              <Button
                variant="contained"
                onClick={handleM365Click}
                disabled={m365SignIn.isPending}
                className="loginButton"
                >
                <Image src="Microsoft_365_logo.svg" alt="Microsoft 365 login" className="loginIcon"></Image>
                <span className="loginButtonText">Sign in with Microsoft</span>
              </Button>
              </div>
            )}
        </Card.Body>
        </Card>
    </div>
  );
}

export default SignIn;